module.exports = [
  {
    title: 'Ремонт дизельных двигателей',
    info:
      'Дизельные двигатели в большинстве случаев весьма надежны и долговечны. Особенно если проходить ТО своевременно. Важно использовать качественное топливо, вовремя менять расходники.  Современные дизеля становятся все сложнее обрастая электроникой, различными навесными системами для обеспечения безотказной работы в разных условиях работы.',
    items: [
      {
        title: 'Капитальный ремонт ДВС',
        info:
          'Капитальный ремонт дизельного двигателя одна из самых трудоемких операций по ремонту дизельных авто. Если по результатам диагностики выявлена неисправность в ДВС, двигатель нужно будет:',
        list: [
          'демонтировать дизельный двигатель',
          'отмыть детали',
          'произвести дефектовку, осмотр коленвала, параметры зазоров,трещины',
          'ремонт головки блока цилиндров, блока цилиндров, ремонт коленвала'
        ]
      },
      {
        title: 'Замена навесных узлов и агрегатов',
        info:
          'Дизельные двигатели могут быть оборудованы дополнительными устройствами. Наш сервис предоставляют услуги по замене и ремонту некоторых из них. Просим обратить внимание, что некоторые такие устройства не поддаются ремонту. К услугам по ремонту навесным узлам и агрегатам дизельного двигателя относятся:',
        list: [
          'Ремонт, замена турбины(турбонаддув)',
          'впускной/выпускной коллекторы',
          'клапан EGR',
          'помпа'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/engine.js